import {LIST_TRANSFER_WITH_AMOUNT, FETCH_TRANSFER_WITH_AMOUNT} from "./types";

const init = {
    isLoading: false,
    data: [],
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TRANSFER_WITH_AMOUNT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TRANSFER_WITH_AMOUNT:
            return {
                ...state,
                isLoading: false,
                data: payload.data.filter(e => e.items.length > 0),
            };
        default:
            return state

    }
}